import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ChatBoxComponent} from '@app/modules/chat/components/chat-box/chat-box.component';
import {UsersListComponent} from '@app/modules/chat/components/users-list/users-list.component';
import {UserListItemComponent} from '@app/modules/chat/components/user-list-item/user-list-item.component';
import {PopoverModule} from 'ngx-bootstrap/popover';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {FormsModule} from '@angular/forms';
import {SharedModule} from '@app/modules/shared/shared.module';
import { LocalUserListItemComponent } from './components/local-user-list-item/local-user-list-item.component';

@NgModule({
  declarations: [
    ChatBoxComponent,
    UsersListComponent,
    UserListItemComponent,
    LocalUserListItemComponent
  ],
  exports: [
    UsersListComponent,
    ChatBoxComponent
  ],
  imports: [
    CommonModule,
    PopoverModule,
    BsDropdownModule,
    FormsModule,
    SharedModule
  ]
})
export class ChatModule { }
